























































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { PageBase } from "@/core/models/shared";
import { AlertSimpleErr, AlertSimpleRes, AutenticadorService } from "@/core/services/shared";
import { LoginModel } from "@/core/models/shared/model";
import Swal from 'sweetalert2'
import { EditalService } from "@/core/services/geral";
import { AssinanteService } from "@/core/services/sistema/AssinanteService";

@Component
export default class CadastroCliente extends PageBase {
    
    logo: any = false;

    mskCnpj = process.env.VUE_APP_MSK_CNPJ;
    maskCpf = process.env.VUE_APP_MSK_CPF;
    mask = process.env.VUE_APP_MSK_CPF;

    showPassword: boolean = false;
    esqueceuSenha: boolean = false;
    loading: boolean = false;
    acesso: LoginModel = {
        cnpj: '',
        login: '',
        senha: ''
    }

    autenticadorService: AutenticadorService = new AutenticadorService();

    @Watch("acesso.cnpj")
    WatchCpfCnpj(val: any){
        if(val.length > 14){
            this.mask = this.mskCnpj;
        }
        else{
            this.mask = this.maskCpf;        
        }
    }

    mounted() {
        new AssinanteService().GetLogo().then(
            res => {
                this.logo = res.data;
            }
        )   
    }

    Autenticar(){
        this.loading = true;
        this.autenticadorService.AutenticarUsuario(this.acesso).then(
            res => {
                localStorage.setItem('sessionApp', JSON.stringify(res.data));
                if(res.data.dados.ongId){
                    new EditalService().HasProjeto(res.data.dados.ongId).then(
                        res => {
                            if(res.data){
                                this.$router.push({name: "Projeto"});
                            }else{
                                this.$router.push({name: "Home"});
                            }
                        }
                    )
                }else{
                    this.$router.push({name: "Home"});
                }
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Login efetuado com sucesso!',
                    showConfirmButton: false,
                    timer: 1500
                })
            },
            err => AlertSimpleErr("Aviso", err)
        ).finally(() => {
            this.loading = false;
        })
    }

    RedefinirSenha(){
        this.loading = true;
        this.autenticadorService.ResetarSenha(this.acesso.cnpj, this.acesso.login).then(
            res => {
                AlertSimpleRes("Aviso!", res);
                this.$router.replace({name:'login'});
                setTimeout(() =>{
                    location.reload();
                }, 3000);
            },
            err => AlertSimpleErr("Aviso!", err)
        ).finally(() => {
            this.loading = false;
        })
    }

    CriarConta(){
        var subdominio = window.location.host.split(".")[0];
        if(subdominio == "edital"){
            window.open("https://laboratorio.portalongfacil.com.br/cadastro/empresa", "_blank")?.focus();
        }
        else{
            window.open(`https://sistema.portalongfacil.com.br/cadastro/empresa?origem=${subdominio}`, "_blank")?.focus();
        }
    }
}

